// extracted by mini-css-extract-plugin
export var container = "ShadowEgg-module--container--tcCsx";